import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    const mainCarousel = new Flickity($element.find('.carousel').get()[0], {
      prevNextButtons: false,
      pageDots: false,
      hash: true,
      cellAlign: 'left',
      draggable: false,
      wrapAround: true,
      autoPlay: false,
      on: {
        ready: function() {
          window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
        },
      },
    });

    var carouselProperties = {
      playSpeed: 5000,
      progress: 0,
      slide: 0,
      maxSlides: mainCarousel.slides.length,
    };

    setInterval(() => {
      carouselProperties.progress += 50;

      if (carouselProperties.progress > carouselProperties.playSpeed) {
        carouselProperties.slide++;
        carouselProperties.progress = 0;

        if (carouselProperties.slide >= carouselProperties.maxSlides) {
          carouselProperties.slide = 0;
        }

        mainCarousel.select(carouselProperties.slide);

        // Reset all goto items
        $element.find('.carousel-wrapper .slide-goto .fill').css({ transform: 'rotate(0)' });
        $element.find('.carousel-wrapper .slide-goto').removeClass('active');
      }

      // Set CSS elements of goto item.
      const $goto = $element.find(`.carousel-wrapper .slide-goto[data-slide-index="${carouselProperties.slide}"]`);
      $goto.addClass('active');

      if (carouselProperties.progress < (carouselProperties.playSpeed / 2)) {
        // Less than halfway
        const amount = 180 / ((carouselProperties.playSpeed / 2) / carouselProperties.progress);
        $goto.find('.hold.hold-top .fill').css({ transform: `rotate(${amount}deg)` });
      } else {
        // Snap to correct amount
        $goto.find('.hold.hold-top .fill').css({ transform: 'rotate(180deg)' });

        // More than halfway
        const amount = 180 / ((carouselProperties.playSpeed / 2) / (carouselProperties.progress - (carouselProperties.playSpeed / 2)));
        $goto.find('.hold.hold-bottom .fill').css({ transform: `rotate(${amount}deg)` });
      }

    }, 50);

    // Goto.
    $element.find('.carousel-wrapper .slide-goto').on('click', function() {
      const slideIndex = $(this).data('slide-index');

      if (carouselProperties.slide != slideIndex) {
        carouselProperties.progress = 0;
        carouselProperties.slide = slideIndex;
        mainCarousel.select(slideIndex);

        // Reset all goto items
        $element.find('.carousel-wrapper .slide-goto .fill').css({ transform: 'rotate(0)' });
        $element.find('.carousel-wrapper .slide-goto').removeClass('active');
      }
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/home/carousel.js